import React from 'react'
import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import BasicLgyInputField from 'app/components/util/lgy-input-field/BasicLgyInputField'

const PropertyDescriptionAndPurchaserSection = ({ assignmentDetails, isUploadingDisabled, invalidMessage, streetNumber, addressLineOne, addressLineTwo, city, zipPrefix, zipSuffix, handleChange, handleInvalid }) =>
  <LgySubsection header={`Property Description${(assignmentDetails.appraisalCode === 'LAPP' || assignmentDetails.appraisalCode === 'IND') ? ' & Purchaser Details' : ''}`}
    className='property-description-and-purchaser-section'>
    <fieldset id='propertyDescriptionForm' disabled={isUploadingDisabled}>
      <legend className='usa-sr-only'>Property Address Form</legend>
      <BasicLgyInputField className='usa-input-medium' id='streetNumber' name='streetNumber' type='text' maxLength='10' value={streetNumber}
        label='Street Number' required onChange={handleChange} onInvalid={handleInvalid}
        dirty={streetNumber === assignmentDetails.streetNumber || streetNumber === '' ? 0 : 1}
        error={invalidMessage.find(error => error.startsWith('Street Number')) ? 'Required' : undefined} />

      <BasicLgyInputField id='addressLineOne' name='addressLineOne' type='text' maxLength='50' value={addressLineOne}
        label='Address Line One' required onChange={handleChange} onInvalid={handleInvalid}
        dirty={addressLineOne === assignmentDetails.addressOne || addressLineOne === '' ? 0 : 1}
        error={invalidMessage.find(error => error.startsWith('Address Line One')) ? 'Required' : undefined} />

      <BasicLgyInputField id='addressLineTwo' name='addressLineTwo' type='text' maxLength='25' value={addressLineTwo}
        label='Address Line Two' onChange={handleChange} onInvalid={handleInvalid}
        dirty={addressLineTwo === assignmentDetails.addressTwo || addressLineTwo === '' ? 0 : 1} />

      <BasicLgyInputField id='city' name='city' type='text' maxLength='20' value={city} required
        label='City' onChange={handleChange} onInvalid={handleInvalid}
        dirty={city === assignmentDetails.city || city === '' ? 0 : 1}
        error={invalidMessage.find(error => error.startsWith('City')) ? 'Required' : undefined} />

      <div className='non-input'>County: {assignmentDetails.county}</div>
      <div className='non-input'>State: {assignmentDetails.state}</div>

      {/*Can't use lgy input fields here for styling reasons, the divs get in the way*/}
      <div className={invalidMessage.find(error => error.startsWith('Zip')) ? 'usa-input-error' : ''}>
        <label id='zip'>Zip</label>
        {invalidMessage.find(error => error.startsWith('Zip')) && <span className='usa-input-error-message' role='alert'>Required</span>}
        <input style={{ display: 'inline' }} className={zipPrefix === assignmentDetails.zip || zipPrefix === '' ? 'usa-input-medium' : 'usa-input-success usa-input-medium'}
          aria-labelledby='zip' id='zipPrefix' name='zipPrefix' value={zipPrefix} type='text' required aria-required onChange={handleChange} pattern='[0-9]*'
          onInvalid={handleInvalid} maxLength='5' placeholder='Zip' />
        &nbsp;–&nbsp;
        <input style={{ display: 'inline', border: '.1rem solid #5b616b' }}
          className={zipSuffix === assignmentDetails.zipPlusFour || zipSuffix === '' ? 'usa-input-tiny' : 'usa-input-success usa-input-tiny'} aria-labelledby='zip'
          id='zipSuffix' name='zipSuffix' value={zipSuffix} type='text' onChange={handleChange} pattern='[0-9]*' onInvalid={handleInvalid} maxLength='4' placeholder='+4' />
      </div>

      {(assignmentDetails.appraisalCode === 'LAPP' || assignmentDetails.appraisalCode === 'IND') &&
        (assignmentDetails.salePrice ?
          <div className='non-input'>Purchaser Name: {assignmentDetails.purchaserFirstName} {assignmentDetails.purchaserMiddleName ? assignmentDetails.purchaserMiddleName + ' ' : ''}{assignmentDetails.purchaserLastName}</div>
          : <div className='non-input'>Owner Name: {assignmentDetails.ownerName}</div>)}
    </fieldset>
  </LgySubsection>

export default PropertyDescriptionAndPurchaserSection